<div
  class="attribute-editor-component"
  rvSpinner="domo-editor-loader"
  [rvShowSpinner]="isLoading"
>
  <div class="attribute-editor-row">
    <div class="form-group">
      <label class="control-label" for="te-domo-url">Domo URL</label>
      <div class="domo-url-input-wrapper">
        <input
          type="text"
          id="te-domo-url"
          name="te-domo-url"
          class="form-control u_ellipsis"
          [class.is-validating]="isValidating"
          [(ngModel)]="source"
          placeholder="Enter Domo URL"
          (debounceEvent)="onAttributeChanged()"
        />
        @if (isValidating) {
          <span class="domo-url-spinner-wrapper">
            <i
              aria-label="Validating"
              class="fa fa-spinner fa-spin domo-url-spinner"
            ></i>
          </span>
        }
      </div>
      @if (source && validationStatus.status === 'INVALID_SOURCE') {
        <p class="help-block text-danger">Invalid Domo URL.</p>
      } @else if (
        source &&
        validationStatus.isPrivate &&
        validationStatus.status === 'MISSING_CREDENTIALS'
      ) {
        <p class="help-block text-muted">
          This URL is private. To access it, connect your Domo account in your
          <a
            uiSref="apps.settings.integrations.open"
            [uiParams]="{ integrationId: 'domo' }"
            class="madero-link"
            >Integrations</a
          >.
        </p>
      } @else if (
        source &&
        validationStatus.isPrivate &&
        validationStatus.status === 'INVALID_CREDENTIALS'
      ) {
        <p class="help-block text-danger">
          Invalid Domo credentials. Update them in your
          <a
            uiSref="apps.settings.integrations.open"
            [uiParams]="{ integrationId: 'domo' }"
            class="madero-link"
            >Integrations</a
          >
        </p>
      } @else if (
        source &&
        !validationStatus.isPrivate &&
        validationStatus.status === 'VALID'
      ) {
        <p class="help-block text-success">Valid public Domo URL.</p>
      } @else if (
        source &&
        validationStatus.isPrivate &&
        validationStatus.status === 'VALID'
      ) {
        <p class="help-block text-success">
          Your company is connected to a Domo account. An admin can update it in
          <a
            uiSref="apps.settings.integrations.open"
            [uiParams]="{ integrationId: 'domo' }"
            class="madero-link"
            >Integrations</a
          >.
        </p>
      } @else if (validationStatus.status === 'INTERNAL_ERROR') {
        <p class="help-block text-danger">
          An error occurred while validating the Domo URL. Please try again.
        </p>
      }
    </div>
  </div>

  <div class="attribute-editor-row">
    <div class="form-group">
      <label class="control-label" for="te-domo-filters">Filters</label>
      <input
        type="text"
        id="te-domo-filters"
        name="te-domo-filters"
        class="form-control"
        [(ngModel)]="filters"
        placeholder="Enter optional filters"
        (debounceEvent)="onAttributeChanged()"
      />
      @if (source && filters && validationStatus.status === 'INVALID_FILTERS') {
        <p class="help-block text-danger">Invalid filters.</p>
      } @else if (
        source &&
        filters &&
        !validationStatus.isPrivate &&
        validationStatus.status === 'MISSING_CREDENTIALS'
      ) {
        <p class="help-block text-danger">
          Filters require a Domo connection. Connect your Domo account in
          <a
            uiSref="apps.settings.integrations.open"
            [uiParams]="{ integrationId: 'domo' }"
            class="madero-link"
            >Integrations</a
          >.
        </p>
      } @else if (
        source &&
        filters &&
        !validationStatus.isPrivate &&
        validationStatus.status === 'INVALID_CREDENTIALS'
      ) {
        <p class="help-block text-danger">
          Invalid Domo credentials. Update them in your
          <a
            uiSref="apps.settings.integrations.open"
            [uiParams]="{ integrationId: 'domo' }"
            class="madero-link"
            >Integrations</a
          >
        </p>
      }
    </div>
  </div>
</div>
